var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"woo-help-outer"},[_c('div',{staticClass:"woo-help-view"},[_c('helper-playlist',{attrs:{"urlAware":"true","onCloseHelp":_vm.onCloseHelp}})],1)])}
var staticRenderFns = []

export { render, staticRenderFns }